module.exports = __webpack_public_path__ + "static/media/Suzuki.96f7cb78.jpeg";